module.exports = __webpack_public_path__ + "static/media/jp.4187b1d4.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/jp.svg
// module id = 682
// module chunks = 0